<template>
    <div class="FormationsList FormationsList--memberarea">
        <div v-if="suggestions.length < 1" class="FormationsList__loader">
            <i class="fas fa-spinner fa-spin"></i>
        </div>
        <a v-if="haveJobPossibility" target="_blank" href="http://www.onisep.fr/" class="JobPossibility">
            <job-icon height="25" width="25" color="#fff"/>
            <div>
                <h2 class="JobPossibility__title">Emploi</h2>
                <p class="JobPossibility__description">En savoir plus avec le site de l'Onisep</p>
            </div>
        </a>
        <article v-for="formation in suggestions" class="FormationCard m-b-50">
            <header class="FormationCard__header">
                <h2 @click.prevent="open(formation)" class="FormationCard__title">{{ formation.name }}</h2>
            </header>
            <div class="FormationCard__content">
                <p class="FormationCard__description">
                    {{ formation.excerpt.replace(/(<([^>]+)>)/ig,"").substr(0, 140) }}
                </p>
                <a @click.prevent="open(formation)" class="FormationCard__more">
                    En savoir plus
                </a>
                <button type="button" @click="register(formation)" class="Btn Btn--primary">Je m'inscris</button>
            </div>
        </article>
    </div>
</template>

<script>
    import FormationIcon from "../icons/FormationIcon";
    import JobIcon from "../icons/JobIcon";
    import Multiselect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css';
    import {actions, getters} from "../../store";
    import UserType from "../../enums/UserType";

    export default {
        components: {FormationIcon, JobIcon, Multiselect},
        data: function () {
            return {
                haveJobPossibility: false
            }
        },
        computed: {
            folders: getters.folders,
            suggestions: getters.suggestions,
            userType: function () {
                return getters.user()?.type;
            },
            folder(){
                return this.folders.find(folder => folder.id === this.folderId);
            },
            folderId() {
                if (this.userType === UserType.LEARNER) {
                    if (this.folders.length <= 0) {
                        return null;
                    }

                    return this.folders[0].id;
                }

                return this.$route.params.folderId;
            }
        },
        watch: {
            folderId: async function () {
                if (this.folderId) {
                    await actions.fetchSuggestions(this.folderId);
                }
            },
            suggestions: function () {
                this.haveJobPossibility = !!this.folder?.formations.find(formation => formation.deliver_job);
            }
        },
        methods: {
            register(formation) {
                let {id, rncp, ref, name, campuses, register_link} = formation;
                if (register_link){
                    window.open(register_link);
                    return;
                }

                this.$root.openFormation({
                    id,
                    rncp,
                    name,
                    ref,
                    campuses: campuses.map(campus => ({id: campus.id, name: campus.name}))
                });
            },
            open(formation) {
                if (this.userType === UserType.LEARNER) {
                    this.$router.push({name: 'formations_view', params: {formationId: formation.id}});
                    return;
                }

                this.$router.push({
                    name: 'folders_formation',
                    params: {folderId: this.folderId, formationId: formation.id}
                });
            }
        },
        created() {
            if (this.folderId) {
                actions.fetchSuggestions(this.folderId);
            }
        }
    }
</script>
